export const OPEN_NETWORK_REGISTRATIONS_RESET_STATE = 'OPEN_NETWORK_REGISTRATIONS_RESET_STATE';
export const OPEN_NETWORK_REGISTRATIONS_CURRENT_ITEM = 'OPEN_NETWORK_REGISTRATIONS_CURRENT_ITEM';

export const OPEN_NETWORK_REGISTRATIONS_REQUEST_LOADING = 'OPEN_NETWORK_REGISTRATIONS_REQUEST_LOADING';
export const OPEN_NETWORK_REGISTRATIONS_REQUEST_SUCCESS = 'OPEN_NETWORK_REGISTRATIONS_REQUEST_SUCCESS';
export const OPEN_NETWORK_REGISTRATIONS_REQUEST_FAILED = 'OPEN_NETWORK_REGISTRATIONS_REQUEST_FAILED';

export const OPEN_NETWORK_REGISTRATIONS_CURRENT_ACTION = 'OPEN_NETWORK_REGISTRATIONS_CURRENT_ACTION';
export const OPEN_NETWORK_REGISTRATIONS_RESET_ACTION = 'OPEN_NETWORK_REGISTRATIONS_RESET_ACTION';